import moduleLocator from 'moduleLocator';
import * as actions from './actions';
import * as components from './components';
import * as constants from './constants';
import * as epics from './epics';
import reducer from './reducer';
import * as selectors from './selectors';
import * as types from './types';
import * as utils from './utils';

const stream = {
    constants,
    actions,
    types,
    reducer,
    selectors,
    components,
    utils,
    epics,
};

moduleLocator.set('stream', { default: stream });

export type { types as Stream };

export default stream;
